
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_wu047_5",
  "marker--line": "awsui_marker--line_1isd1_wu047_20",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_wu047_24",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_wu047_28",
  "marker--dashed": "awsui_marker--dashed_1isd1_wu047_40"
};
  